import React, { useEffect, useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import ToggleButton from '@mui/material/ToggleButton';
import Fade from '@mui/material/Fade';
import RaceInfoDrawer from "../info_components/RaceInfo"


function CheckBox({ race, onClick, label, color, activeRaceAll }) {
    return (
        <div className="raceContainer">

            <FormControlLabel
                control=
                {<Checkbox
                    id={race.race}
                    checked={race.selected}
                     onChange={(event) => {
        if (activeRaceAll) {
            // Auto-uncheck "Open to All" first
            onClick({
                ...race,
                selected: event.target.checked,
            });
            // Trigger the resetter in parent
        } else {
            onClick({
                ...race,
                selected: event.target.checked,
            });
        }
    }}
                    sx={{
                        padding: "2px"
                        // ,transition: "box-shadow .2s",
                        //     '&:hover': {
                        //         boxShadow: '0 0 0 10px rgba(145, 145, 145, 0.16)',
                        //       },
                        //       '&:before': {
                        //         boxShadow:
                        //           '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
                        //       }
                        , "& .MuiSvgIcon-root": {
                            fontSize: 28,
                            color: { color },
                        }
                        // ,backgroundColor: "transparent"
                        // ,"&.MuiButtonBase-root": {
                        //     disableRipple: false
                        // }
                        // ,"&.MuiCheckbox-root": {
                        // }
                    }}
                />}
                label={label}
            >
            </FormControlLabel>
        </div>
    )
}

function ResetBox({ select, onClick }) {
    return (
        <div className="raceContainer">
            <FormControlLabel
                control=
                {<Checkbox
                    id="open_to_all"
                    checked={select}
                    // {...select === "indeterminate" && {indeterminate:true}}
                    onChange={(event) => {
                        onClick("race", event.target.checked);
                    }}
                    sx={{
                        padding: "2px"
                        , "& .MuiSvgIcon-root": {
                            fontSize: 28,
                            color: "#D8D8D8",
                            fontWeight: "600"
                        }
                        // ,backgroundColor: "transparent"
                        // ,"&.MuiButtonBase-root": {
                        //     disableRipple: false
                        // }
                        // ,"&.MuiCheckbox-root": {
                        // }
                    }}
                ></Checkbox>}
                label="Open to All"
                sx={{
                     "& .MuiTypography-root": {
                        fontWeight: "600"
                    }
                }}
            >
            </FormControlLabel>
        </div>
    )
}

export default function Race({ activeRace, onRaceClick, activeRaceAll, resetter }) {
    const [selectedInfo, setSelectedInfo] = useState(false);
    const [selectedHelp, setSelectedHelp] = useState(false);

    return (
            <div className="componentContainerNarrow" style={{paddingTop:"10px"}}>

            <div className="checkBoxContainerParentRace">
                <Fade
                                        // in={false ? true : false}
                                        in={selectedHelp ? true : false}
                                        timeout={500}
                                    >
                                        <div className="helpContainer" style={{height: "180px"}} onClick={() => { setSelectedHelp(!selectedHelp) }}>
                                            <div className="helpBox">
                                                <h2 className="helpText">Tips</h2>
                                                <p className="helpText">- 🌻 Only one level of specificity may be selected, with Race representing the broadest category and Ancestry the most precise.</p>
                                                <p className="helpText">- ✅ This is the final criteria on this page. When finished, select "2. My Estimates" at the top.</p>
                                            </div>
                                        </div>
                                    </Fade>
                                                    <RaceInfoDrawer selectedInfo={selectedInfo} setSelectedInfo={setSelectedInfo} />
                                    
                <div className="componentHeaderContainer">
                    <div className="componentHeader">
                        <div className="descriptionContainer">
                            <p className="description">Desired race for partner</p>
                        </div>
                        <div className="info">
                            <ToggleButton
                                value={1}
                                selected={selectedInfo}
                                onChange={() => setSelectedInfo((prevSelected) => !prevSelected)}
                                sx={{ padding: '0px', border: '0px', height: "26px", width: "26px" }}
                            >
                                <InfoIcon />
                            </ToggleButton>
                            <ToggleButton
                                    value={1}
                                    selected={selectedHelp}
                                    onChange={() => {setSelectedHelp((prevSelected) => !prevSelected); setSelectedInfo(false)}}
                                    sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                                >
                                    <HelpIcon />
                                </ToggleButton>
                        </div>
                    </div>
                </div>
                <div className="componentHeader">
                    <div>
                    <ResetBox key="open_to_all" select={activeRaceAll} onClick={resetter} />
                    </div>
                </div>

                <FormGroup>
                    {activeRace.map((race) => (
                        <CheckBox key={race.race} race={race} label={race.race} color={race.color} onClick={onRaceClick} activeRaceAll={activeRaceAll}
                        />
                    ))}
                </FormGroup>

                <div>
                    <p className="source">Source: U.S. Census Bureau, 2019-2023 American Community Survey (NYC - S1201) </p>
                </div>
            </div>
        </div>
    );
}